export const findTargetLinear = (
	num1: number,
	num2: number,
	axis: number,
	isLong: boolean,
): number => {
	const target = isLong ? axis + (num1 - num2) : axis - (num1 - num2)

	return Math.round(target * 100) / 100
}
